import { render } from "./ResetPassForm.vue?vue&type=template&id=bacf2ba2"
import script from "./ResetPassForm.vue?vue&type=script&lang=js"
export * from "./ResetPassForm.vue?vue&type=script&lang=js"
script.render = render

export default script